
import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import CardMedia from "@mui/material/CardMedia";

import { getProductDetails } from "../../../../../services/Admin/MenuProductsApi";
import { resolveImageUrl } from "../../../../../services/indexMediaBaseUrl";

const ItemDetailsDialog = ({ open, onClose, productId }) => {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [product, setProduct] = useState(null);

	useEffect(() => {
		let mounted = true;
		const load = async () => {
			if (!open || !productId) return;
			setLoading(true);
			setError("");
			try {
				const res = await getProductDetails(productId);
				const p = res?.data || null;
				if (mounted) setProduct(p);
			} catch (err) {
				if (mounted) setError(err?.message || "Failed to load product details");
			} finally {
				if (mounted) setLoading(false);
			}
		};

		load();
		return () => (mounted = false);
	}, [open, productId]);

	const handleClose = () => {
		setProduct(null);
		setError("");
		onClose && onClose();
	};

	return (
		<Dialog
			open={Boolean(open)}
			onClose={handleClose}
			maxWidth="lg"
			fullWidth
			PaperProps={{ sx: { height: "80vh" } }}
		>
			<DialogTitle>تفاصيل الصنف</DialogTitle>

			<DialogContent dividers sx={{ height: "calc(80vh - 120px)", overflowY: "auto" }}>
				{loading ? (
					<Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
						<CircularProgress />
					</Box>
				) : error ? (
					<Box sx={{ color: "error.main", p: 2 }}>{String(error)}</Box>
				) : product ? (
					<Grid container spacing={2}>
						<Grid item xs={12} md={5}>
							<CardMedia
								component="img"
								image={resolveImageUrl(product.image)}
								alt={product.name}
								sx={{ width: "100%", height: 360, objectFit: "cover", borderRadius: 1 }}
							/>
						</Grid>

						<Grid item xs={12} md={7}>
							<Typography variant="h6" gutterBottom>
								{product.name}
							</Typography>

							<Typography variant="body2" color="text.secondary">
								الفئة: {product.category?.name}
							</Typography>

							<Box sx={{ mt: 2 }}>
								<Typography variant="body1">السعر: {product.price}</Typography>
								<Typography variant="body2">زمن التحضير: {product.prepare_time} دقيقة</Typography>
								<Typography variant="body2">الحالة: {product.status === 1 ? "نشط" : "غير نشط"}</Typography>
							</Box>

							<Box sx={{ mt: 2 }}>
								<Typography variant="subtitle2">الوصف:</Typography>
								<Typography variant="body2">{product.description}</Typography>
							</Box>
						</Grid>
					</Grid>
				) : (
					<Box>لا توجد بيانات.</Box>
				)}
			</DialogContent>

			<DialogActions>
				<Button onClick={handleClose}>إغلاق</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ItemDetailsDialog;

